import React, {useState} from 'react';
import IsFetchingInline from '../../common/IsFetchingInline.jsx';
import LivingPlaceForm from './LivingPlaceForm.jsx';


const LivingPlace = (props) => {
  let [editMode, setEditMode] = useState(false);
  const handleClick = () => setEditMode(true);
  const handleCancel = () => {setEditMode(false);};

  const handleSubmit = (formData) => {
    props.onSubmit(formData);
    setEditMode(false);
  };

  return <div>
    <div className="font-weight-bold">{gettext('Откуда')}:</div>
    <p className="small text-secondary">
      {gettext('Для редактирования места жительства кликните по его значению.')}
    </p>
    <div className="cabinet-editable">
      {editMode && <LivingPlaceForm lang={props.lang}
                                    onSubmit={handleSubmit}
                                    onCancel={handleCancel}/>}
      {!editMode &&
      <span className="cabinet-editable__string"
            title={gettext('Редактировать место жительства')}
            onClick={handleClick}>
      {props.livingPlace ? props.livingPlace : gettext('Неуказано')}
      </span>}
      <IsFetchingInline isFetching={props.isFetching}/>
    </div>
  </div>
};

export default LivingPlace;